import { createFeature, createReducer, on } from '@ngrx/store';
import {
  getDepositBonusAvailability,
  getDepositBonusAvailabilitySuccess,
  getDepositBonusAvailabilityFailure,
  getDepositBonusList,
  getDepositBonusListSuccess,
  getDepositBonusListFailure,
  getDepositBonusAmount,
  getDepositBonusAmountSuccess,
  getDepositBonusAmountFailure,
  clearDepositBonusAmount,
} from './actions';

import {
  DepositBonusAmount,
  DepositBonusAvailability,
  DepositBonusList,
} from '../models/deposit-bonus';

export interface DepositBonusState {
  depositBonusAvailability: DepositBonusAvailability | null;
  depositBonusList: { [accountId: number]: DepositBonusList };
  depositBonusAmount: DepositBonusAmount | null;
  isPending: boolean;
}

const initialState: DepositBonusState = {
  depositBonusAvailability: null,
  depositBonusList: {},
  depositBonusAmount: null,
  isPending: false,
};

export const depositBonusFeature = createFeature({
  name: 'depositBonus',
  reducer: createReducer(
    initialState,
    on(getDepositBonusAvailability, (state) => ({ ...state, isPending: true })),
    on(getDepositBonusAvailabilitySuccess, (state, { depositBonusAvailability }) => ({
      ...state,
      depositBonusAvailability,
      isPending: false,
    })),
    on(getDepositBonusAvailabilityFailure, (state) => ({ ...state, isPending: false })),

    on(getDepositBonusList, (state) => ({ ...state, isPending: true })),
    on(getDepositBonusListSuccess, (state, { depositBonusList, accountId }) => ({
      ...state,
      depositBonusList: {
        ...state.depositBonusList,
        [accountId]: depositBonusList,
      },
      isPending: false,
    })),
    on(getDepositBonusListFailure, (state) => ({ ...state, isPending: false })),

    on(getDepositBonusAmount, (state) => ({ ...state, isPending: true })),
    on(getDepositBonusAmountSuccess, (state, { depositBonusAmount }) => ({
      ...state,
      depositBonusAmount,
      isPending: false,
    })),
    on(getDepositBonusAmountFailure, (state) => ({ ...state, isPending: false })),

    on(clearDepositBonusAmount, (state) => ({ ...state, depositBonusAmount: null })),
  ),
});
